// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {BlockWrapSupport} from './block-wrap-support.js'
import {LayoutMode} from './layout-mode.js'
import {MeasurementScale} from './measurement-scale.js'
import {SetPageBackground} from './set-page-background.js'
import {SetSeqId} from './set-seq-id.js'
import {SetString} from './set-string.js'

export class SetMetadata {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetMetadata {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetMetadata(bb: flatbuffers.ByteBuffer, obj?: SetMetadata): SetMetadata {
    return (obj || new SetMetadata()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetMetadata(bb: flatbuffers.ByteBuffer, obj?: SetMetadata): SetMetadata {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetMetadata()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  title(obj?: SetString): SetString | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SetString()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  pageBackground(obj?: SetPageBackground): SetPageBackground | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new SetPageBackground()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  handwritingLanguage(obj?: SetString): SetString | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new SetString()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  alignTextToLines(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  defaultFontFamily(): string | null
  defaultFontFamily(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  defaultFontFamily(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  defaultFontSize(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null
  }

  layoutMode(): LayoutMode | null {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  blockWrapSupport(): BlockWrapSupport | null {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  coverPageId(obj?: SetSeqId): SetSeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? (obj || new SetSeqId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  measurementScale(obj?: MeasurementScale): MeasurementScale | null {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset ? (obj || new MeasurementScale()).__init(this.bb_pos + offset, this.bb!) : null
  }

  measurementsShown(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startSetMetadata(builder: flatbuffers.Builder) {
    builder.startObject(11)
  }

  static addTitle(builder: flatbuffers.Builder, titleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, titleOffset, 0)
  }

  static addPageBackground(builder: flatbuffers.Builder, pageBackgroundOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, pageBackgroundOffset, 0)
  }

  static addHandwritingLanguage(builder: flatbuffers.Builder, handwritingLanguageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, handwritingLanguageOffset, 0)
  }

  static addAlignTextToLines(builder: flatbuffers.Builder, alignTextToLines: boolean) {
    builder.addFieldInt8(3, +alignTextToLines, null)
  }

  static addDefaultFontFamily(builder: flatbuffers.Builder, defaultFontFamilyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, defaultFontFamilyOffset, 0)
  }

  static addDefaultFontSize(builder: flatbuffers.Builder, defaultFontSize: number) {
    builder.addFieldFloat32(5, defaultFontSize, null)
  }

  static addLayoutMode(builder: flatbuffers.Builder, layoutMode: LayoutMode) {
    builder.addFieldInt8(6, layoutMode, null)
  }

  static addBlockWrapSupport(builder: flatbuffers.Builder, blockWrapSupport: BlockWrapSupport) {
    builder.addFieldInt8(7, blockWrapSupport, null)
  }

  static addCoverPageId(builder: flatbuffers.Builder, coverPageIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, coverPageIdOffset, 0)
  }

  static addMeasurementScale(builder: flatbuffers.Builder, measurementScaleOffset: flatbuffers.Offset) {
    builder.addFieldStruct(9, measurementScaleOffset, 0)
  }

  static addMeasurementsShown(builder: flatbuffers.Builder, measurementsShown: boolean) {
    builder.addFieldInt8(10, +measurementsShown, null)
  }

  static endSetMetadata(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }
}
